'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _validation = require('../../utils/validation');

var _formValidation = require('../../helpers/formValidation');

var _formValidation2 = _interopRequireDefault(_formValidation);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var validate = (0, _validation.createValidator)({
  email: _formValidation2.default.email,
  password: _formValidation2.default.password,
  repassword: _formValidation2.default.password
});

exports.default = validate;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/AuthForms/authFormValidation.js
// module id = 816
// module chunks = 1